import { globals, template } from '@yola/ws-sdk';
import constants from 'src/js/modules/website-settings/constants/common';
import store from '../../../store';

const deleteLanguageSelector = () => {
  const state = store.getState();
  const { globalId } = template.selectors.getVariableValueByPath(state, 'languageSelector[0]');
  const languageSelector = document.createElement(constants.LANGUAGE_SELECTOR_TAG);
  languageSelector.hidden = true;

  store.dispatch(globals.actions.setGlobalHTML(globalId, languageSelector.outerHTML));
};

export default deleteLanguageSelector;
